// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"30983f96","283":"ae766358","453":"46dc3e92","795":"46620d84"}[chunkId] + ".chunk.js";
};